import styled from 'styled-components'
import { Layer, Box, IcoMoon } from '@usap/uicomponents'

export const StyledLayer = styled(Layer)`
  z-index: 1000;
  width: inherit;
  ${props => props.fitMobileWidth && 'width: 100%;'}

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    width: inherit;
  }
`

export const PopUpClose = styled(Box)`
  position: absolute;
  right: -4px;
  top: -4px;

  ${props => props.theme.mediaQuery.up('mobile-landscape')} {
    top: -32px;
  }
`

export const PopUpCloseIcon = styled(IcoMoon)`
  fill: #999999;

  ${props => props.theme.mediaQuery.up('mobile-landscape')} {
    fill: #ffffff;
  }
`
